import { useParams } from "react-router";
import { blogData } from "./Array"
import Footer from "./Footer";

function Bloginfo() {
     const { id } = useParams();
     const blog = blogData.find((b) => b.id === id);

  if (!blog) {
    return <h2 className="text-center mt-5">Blog not found</h2>;
  }
  return (
    <>
    <div className="container">
    <div className="container sub-page ">
      <div style={{ padding: "60px 0 0" }} className="d-flex flex-column gap-3">
        {/* <div>
      <h2 className="fw-bold">{blog.title}</h2>
      <p>{blog.intro}</p>
    </div> */}
    {/* <div>
        <h4>Why Are There Different Types of Bank Accounts?</h4>
        <p>People use banks for various purposes such as saving money, daily transactions, business operations, or long term investments. To meet these needs, banks offer different account types, each with its own features and benefits.</p>
    </div> */}
    {/* <div>
        <h4>1.Savings Account</h4>
        <p>A savings account is one of the most common types of bank accounts. It is primarily used to store money safely while earning interest. Savings accounts allow limited transactions and are suitable for personal use.</p>
        <p>Key features include:</p>
        <ul className="pl-3">
            <li>Interest on deposited funds</li>
            <li>Easy access to money</li>
            <li>Low minimum balance requirements</li>
        </ul>
    </div> */}
    {/* <div>
        <h4>2.Current Account</h4>
        <p>A current account is mainly used by businesses, traders, and professionals who require frequent transactions. These accounts are designed for high volume transactions and usually do not offer interest.</p>
        <p>Key features include:</p>
        <ul className="pl-3">
            <li>Unlimited deposits and withdrawals</li>
            <li>Overdraft facilities in some cases</li>
            <li>Suitable for business operations</li>
        </ul>
    </div> */}
    {/* <div>
        <h4>3.Fixed Deposit Account</h4>
        <p>A fixed deposit account allows users to deposit a lump sum for a fixed period at a predetermined interest rate. The money remains locked for the chosen duration, encouraging long term savings.</p>
        <p>Key features include:</p>
        <ul className="pl-3">
            <li>Fixed interest rate</li>
            <li>Predictable returns</li>
            <li>Suitable for long-term financial planning</li>
        </ul>
    </div> */}
    {/* <div>
        <h4>4.Recurring Deposit Account</h4>
        <p>A recurring deposit account helps individuals save money regularly by depositing a fixed amount every month. It is ideal for people who want to develop a consistent saving habit.</p>
        <p>Key features include:</p>
        <ul className="pl-3">
            <li>Monthly deposits</li>
            <li>Fixed tenure</li>
            <li>Encourages disciplined savings</li>
        </ul>
    </div> */}
    {/* <div>
        <h4>Choosing the Right Account</h4>
        <p>The right bank account depends on individual needs such as income, spending habits, and financial goals. Understanding the purpose of each account type helps users make informed choices.</p>
        <p>Selecting the appropriate bank account is an important step toward effective money management and financial stability.</p>
    </div> */}
     {/* {blog.sections.map((section, index) => (
          <div key={index}>
            <h4>{section.heading}</h4>
            <p className="">{section.content}</p>

            {section.points && (
              <ul className="pl-3">
                {section.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}
          </div>
        ))} */}
         <div>
          <h2 className="fw-bold">{blog.title}</h2>

          {/* Intro: string OR array */}
          {Array.isArray(blog.intro) ? (
            blog.intro.map((text, i) => (
              <p className="mb-0 mt-3" key={i}>{text}</p>
            ))
          ) : (
            <p>{blog.intro}</p>
          )}
        </div>

        {/* Sections */}
        {blog.sections.map((section, index) => (
          <div key={index} className="d-flex flex-column gap-2">
            <h4>{section.heading}</h4>

            {/* Content: string OR array */}
            {Array.isArray(section.content) ? (
              section.content.map((text, i) => (
                <p className="mb-0" key={i}>{text}</p>
              ))
            ) : (
              <p className="mb-0">{section.content}</p>
            )}

            {/* Points */}
            {section.points && (
              <ul className="pl-3">
                {section.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            )}
            <p>{section.h2}</p>
          </div>
        ))}
    
      </div>
      </div>
      </div>
       <Footer />
    </>
  )
}

export default Bloginfo
